import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';

interface ArticleCardProps {
  article: Article;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  return (
    <article className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden group hover:border-primary-200 transition-all duration-300">
      <Link to={`/article/${article.id}`} className="block">
        <div className="relative w-full h-48 overflow-hidden">
          <img
            src={article.imageUrl}
            alt={article.title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            title={`${article.title} - 白洁传研究中心`}
          />
          <div className="absolute top-3 left-3">
            <span className="inline-block px-2.5 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-medium whitespace-nowrap">
              {article.categoryName}
            </span>
          </div>
        </div>
      </Link>
      <div className="p-5">
        <Link to={`/article/${article.id}`} className="block group/title">
          <h3 className="font-heading text-base font-semibold text-foreground-950 leading-snug group-hover/title:text-primary-600 transition-colors line-clamp-2">
            {article.title}
          </h3>
        </Link>
        <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-2">
          {article.excerpt}
        </p>
        <div className="mt-4 flex items-center justify-between text-xs text-foreground-500">
          <div className="flex items-center gap-3">
            <span className="flex items-center gap-1">
              <i className="ri-calendar-line"></i>
              {article.date}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-time-line"></i>
              {article.readTime}
            </span>
          </div>
          <Link
            to={`/article/${article.id}`}
            className="flex items-center gap-1 text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap transition-colors"
          >
            阅读全文
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </article>
  );
}